export const mapUserRegistration = values => ({
  name: values.name,
  lastName: values.lastName,
  documentIdentifier: values.documentIdentifier,
  email: values.email,
  cellphone: values.cellphone,
  acceptPromo: values.acceptPromo
})
